module.exports = __webpack_public_path__ + "img/task-square.d066f243.svg";